var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DowngradeHeader'),_vm._v(" "),_c('div',{staticClass:"downgrade-page__content"},[_c('div',{staticClass:"gr px-3 md:px-6"},[_c('DowngradeFeaturesList'),_vm._v(" "),_c('DowngradeForm')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }